export default "__VITE_ASSET__XvbQsaTr4wqLc1AJ_nqnpQ__"